import { render, staticRenderFns } from "./index.vue?vue&type=template&id=74d08c06&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {PartnersUsPage: require('/var/www/app/components/partners/PartnersUsPage.vue').default,PartnersOldPage: require('/var/www/app/components/partners/PartnersOldPage.vue').default})
